import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistroUsuarioServiceService {
  public idUsuario: string;
  public modalCodigo: boolean;
  public correoUsuario: string;
  public correoVerificado: boolean;
  public rutaCodVerif: string;
  public textoLoginReenvio: string;
  public checkout: boolean;

  $compRegister = new EventEmitter<any>();
  private closeModalSubject = new BehaviorSubject<boolean>(false);
  closeModal$ = this.closeModalSubject.asObservable();

  private closeModalLoginSubject = new BehaviorSubject<boolean>(false);
  closeModalLogin$ = this.closeModalLoginSubject.asObservable();

  private closeModalFinveroSubject = new BehaviorSubject<boolean>(false);
  closeModalFinvero$ = this.closeModalFinveroSubject.asObservable();

  private closemodalFacturaInvitadoSubject = new Subject<any>();  
  closemodalFacturaInvitado$ = this.closemodalFacturaInvitadoSubject.asObservable();

  private closeModalRegisterSubject = new BehaviorSubject<boolean>(false);
  closeModalRegister$ = this.closeModalRegisterSubject.asObservable();
  
  constructor(private http:HttpClient) { }

  registrarUsuario(modelo){
    return this.http.post(environment.API_SECURITY+'/api/Authentication/InsertarAfiliado',modelo);
  }

  activarUserCodigo(codigo: string, idUser: string) {
    return this.http.get(environment.API_SECURITY+'/api/Authentication/ActivarUsuario/' + idUser + '/' + codigo)
  }

  reenviarCodigo(correo: string) {
    return this.http.get(environment.API_SECURITY+'/api/Authentication/EnviarCodigo/' + correo);
  }

  obtenerIdUserRegistro(idUser: string) {
    this.idUsuario = idUser;
  }

  obtenerCorreo(correo: string) {
    this.correoUsuario = correo;
  }

  changeStatusModal(status: boolean) {
    this.modalCodigo = status;
  }

  obtenerStatusVerificacion(status: boolean) {
    this.correoVerificado = status;
  }

  obtenerTextoModalCodigoLogin(text: string) {
    this.textoLoginReenvio = text;
  }

  cerrarModal(closeModal: boolean) {
    this.closeModalSubject.next(closeModal);
  }

  cerrarModalLogin(closeModal: boolean) {
    this.closeModalLoginSubject.next(closeModal);
  }


  cerrarModalFinvero(closeModal: boolean) {
    this.closeModalFinveroSubject.next(closeModal);
  }

  cerrarmodalFacturaInvitado(closeModal: boolean, data: any) {
    this.closemodalFacturaInvitadoSubject.next({ closeModal, data });
  }
  
  getCloseModalData() {
    return this.closemodalFacturaInvitadoSubject.asObservable();
  }

  cerrarModalRegister(closeModal: boolean) {
    this.closeModalRegisterSubject.next(closeModal);
  }

  obtenerRutaRedirigir(text: string) {
    this.rutaCodVerif = text;
  }

  vieneDeCheckout(status: boolean) {
    this.checkout = status;
  }
}
